const _config = {
  dev: {
    REACT_APP_ENV: 'dev',
    REACT_APP_PAYMENT_SERVICE:'https://payments-dev.fortellis.io',
    REACT_APP_CONSENT_GRAPH_URL: 'https://subscription-portal-dev.fortellis.io/graphql',
    REACT_APP_MP_DP_METADATA_URL: 'https://mp-dp-subscription-metadata-svc-dev.fortellis.io',
    REACT_APP_CONSENT_SERVICE_URL: 'https://cdk-preprod-stage.apigee.net/',
    REACT_APP_MARKETPLACE_URL: 'https://marketplace-dev.fortellis.io/',
    REACT_APP_AUTHORIZE_URL:
      'https://fortellis-connect-cdk-proxy.na-dit.connectcdk.com',
    REACT_APP_NAV_DEVELOPER_COMMUNITY_URL: '#',
    REACT_APP_NAV_MARKETPLACE_URL: '#',
    REACT_APP_NAV_DEVELOPER_APIS_URL: '#',
    REACT_APP_NAV_DOCS_URL: 'https://docs-dev.fortellis.io',
    REACT_APP_CONTACT_US_URL: '#',
    REACT_APP_BLOG_URL: '#',
    REACT_APP_LEGAL_URL: 'https://www-dev.fortellis.io/privacy-legal',
    REACT_APP_TERMS_URL: 'https://www-dev.fortellis.io/terms-use',
    FORGET_PASSWORD_LINK: 'https://sso.dealersuite.com/idp/forgotLogin',
    ORGANIZATION_URL: 'https://organizations-dev.fortellis.io/v1',
    SIGNING_REDIRECT_URL: 'https://subscription-portal-dev.fortellis.io/redirecting',
    REACT_APP_MP_SALESFORCE_INTEGRATION:
      'https://marketplace-salesforce-integration-dev.fortellis.io',
    EXSTING_DEALER_PORTAL: 'https://ds-dev.fortellis.io',
    REACT_APP_AMPLITUDE: '4348c2d0bc76c7c47376e3febc3554a9',
    REACT_APP_API_SUBSCRIPTION_URL: 'https://subscriptions-dev.fortellis.io',
    REACT_APP_DEALERSUITE_URL: 'https://subscription-portal-dev.fortellis.io/',
    MONETIZATION_SERVICE_AGREEMENT_DOC_URL: "https://marketplace-dev-admin-dealer-consent-docs.s3.us-west-2.amazonaws.com/MonetisationServiceAgreement/Fortellis+-+Stripe+-+Dealer+Addendum+to+Master+Services+Agreement.pdf",
    CONNECT_CDK_FORGOT_PASSWORD_URL: "https://login-dit.connectcdk.com/login/forgot-password",
    DATA_RIGHTS_PDF: "https://marketplace-dev-data-rights-consent.s3.us-west-2.amazonaws.com/DataRightsConsent.pdf",
    REACT_APP_PRIVACY_PROTECTION_URL: 'https://consumer-privacy-protection-dev.fortellis.io',
    REACT_APP_SHOW_INTEGRATIONS_SCREEN: true,
    REACT_APP_SHOW_VERTICAL_SCOPING_SCREEN: true,
    REACT_APP_DAAB_HARNESS_CLIENT_SDK_KEY: 'ea67aadb-2466-45ad-8b40-f21ebcfe6ba1',
    REACT_APP_DAAB_FEATURE_FLAG : 'dealer_api_buyer_controlled_access',
    REACT_APP_DEALER_API_BUYER_DOC: "https://fortellis-consent-documents-dev.s3.us-west-2.amazonaws.com/dealer-api-buyer-flow/DealerAPIBuyer.pdf",
    ENABLE_MANAGE_INTEGRATIONS_V2: true,
    REACT_APP_DEALER_API_BUYER_SERVICE_URL: "https://dealer-api-buyer-dev.fortellis.io",
    REACT_APP_API_GATEWAY: "https://api-gateway-dev.fortellis.io",
    REACT_APP_ASYNC_API_SERVICE: "https://async-apis-control-dev.fortellis.io",
    REACT_APP_API_EMAIL_DISPATCHER_SERVICE:"https://ggqwwur628.execute-api.us-west-2.amazonaws.com/api/email",
    REACT_APP_API_EMAIL_SOLUTION_SERVICE:"https://solutions-dev.fortellis.io",
    REACT_APP_UTILIZATION_SERVICE_URL:"https://utilization-dev.fortellis.io",
    REACT_APP_METRICS_SERVICE_URL : "https://core-dev.fortellis.io/v1",
    REACT_APP_API_GATEWAY_DIRECTORY_URL: "https://api-gateway-dev.fortellis.io/v3",
    REACT_APP_METRICS_SERVICE_URL_V1: "https://metrics-dev.fortellis.io/v1",
    REACT_APP_DAAB_HIDE_DEALER_PURCHASE: 'daab_hide_dealer_purchase',
    REACT_APP_BUNDLE_PRICING_ENABLED: 'BUNDLE_PRICING_ENABLED',
    REACT_APP_NAV_CASE_MANAGEMENT_URL:"https://cdkdataservices--playground.sandbox.my.site.com/ISVPortal"
  },
  qat: {
    REACT_APP_ENV: 'qat',
    REACT_APP_PAYMENT_SERVICE:'https://payments-qat.fortellis.io',
    REACT_APP_CONSENT_GRAPH_URL: 'https://subscription-portal-qat.fortellis.io/graphql',
    REACT_APP_MP_DP_METADATA_URL:
      'https://mp-dp-subscription-metadata-svc-qat.fortellis.io',
    REACT_APP_CONSENT_SERVICE_URL: 'https://cdk-preprod-stage.apigee.net/',
    REACT_APP_MARKETPLACE_URL: 'https://marketplace-qat.fortellis.io/',
    REACT_APP_AUTHORIZE_URL: 'https://fortellis-connect-cdk-proxy-qa.na-dit.connectcdk.com',
    REACT_APP_NAV_DEVELOPER_COMMUNITY_URL: '#',
    REACT_APP_NAV_MARKETPLACE_URL: '#',
    REACT_APP_NAV_DEVELOPER_APIS_URL: '#',
    REACT_APP_NAV_DOCS_URL: 'https://docs-qat.fortellis.io',
    REACT_APP_CONTACT_US_URL: '#',
    REACT_APP_BLOG_URL: '#',
    REACT_APP_LEGAL_URL: 'https://www-qat.fortellis.io/privacy-legal',
    REACT_APP_TERMS_URL: 'https://www-qat.fortellis.io/terms-use',
    FORGET_PASSWORD_LINK: 'https://sso.dealersuite.com/idp/forgotLogin',
    ORGANIZATION_URL: 'https://organizations-qat.fortellis.io/v1',
    SIGNING_REDIRECT_URL: 'https://subscription-portal-qat.fortellis.io/redirecting',
    REACT_APP_MP_SALESFORCE_INTEGRATION:
      'https://marketplace-salesforce-integration-qat.fortellis.io',
    EXSTING_DEALER_PORTAL: 'https://ds-qat.fortellis.io',
    REACT_APP_AMPLITUDE: '4348c2d0bc76c7c47376e3febc3554a9',
    REACT_APP_API_SUBSCRIPTION_URL: 'https://subscriptions-qat.fortellis.io',
    REACT_APP_DEALERSUITE_URL: 'https://subscription-portal-qat.fortellis.io/',
    MONETIZATION_SERVICE_AGREEMENT_DOC_URL: "https://marketplace-qat-admin-dealer-consent-docs.s3.us-west-2.amazonaws.com/MonetisationServiceAgreement/Fortellis+-+Stripe+-+Dealer+Addendum+to+Master+Services+Agreement.pdf",
    CONNECT_CDK_FORGOT_PASSWORD_URL: "https://login-perf.connectcdk.com/login/forgot-password",
    DATA_RIGHTS_PDF: "https://marketplace-qat-data-rights-consent.s3.us-west-2.amazonaws.com/DataRightsConsent.pdf",
    REACT_APP_PRIVACY_PROTECTION_URL: 'https://consumer-privacy-protection-qat.fortellis.io',
    REACT_APP_SHOW_INTEGRATIONS_SCREEN: true,
    REACT_APP_SHOW_VERTICAL_SCOPING_SCREEN: true,
    REACT_APP_DAAB_HARNESS_CLIENT_SDK_KEY: '4b560f66-433f-4439-892e-74737d72d638',
    REACT_APP_DAAB_FEATURE_FLAG : 'dealer_api_buyer_controlled_access',
    REACT_APP_DEALER_API_BUYER_DOC: "https://fortellis-consent-documents-qat.s3.us-west-2.amazonaws.com/dealer-api-buyer-flow/DealerAPIBuyer.pdf",
    REACT_APP_DEALER_API_BUYER_SERVICE_URL: "https://dealer-api-buyer-qat.fortellis.io",
    ENABLE_MANAGE_INTEGRATIONS_V2: true,
    REACT_APP_API_GATEWAY: "https://api-gateway-qat.fortellis.io",
    REACT_APP_ASYNC_API_SERVICE: "https://async-apis-control-qat.fortellis.io",
    REACT_APP_API_EMAIL_DISPATCHER_SERVICE:"https://4pb35k3dj8.execute-api.us-west-2.amazonaws.com/api/email",
    REACT_APP_API_EMAIL_SOLUTION_SERVICE:"https://solutions-qat.fortellis.io",
    REACT_APP_UTILIZATION_SERVICE_URL:"https://utilization-qat.fortellis.io",
    REACT_APP_METRICS_SERVICE_URL : "https://core-qat.fortellis.io/v1",
    REACT_APP_API_GATEWAY_DIRECTORY_URL: "https://api-gateway-qat.fortellis.io/v3",
    REACT_APP_METRICS_SERVICE_URL_V1:"https://metrics-qat.fortellis.io/v1",
    REACT_APP_DAAB_HIDE_DEALER_PURCHASE: 'daab_hide_dealer_purchase',
    REACT_APP_BUNDLE_PRICING_ENABLED: 'BUNDLE_PRICING_ENABLED',
    REACT_APP_NAV_CASE_MANAGEMENT_URL: "https://cdkdataservices--playground.sandbox.my.site.com/ISVPortal"
  },
  prod: {
    REACT_APP_ENV: 'prod',
    REACT_APP_PAYMENT_SERVICE:'https://payments.fortellis.io',
    REACT_APP_CONSENT_GRAPH_URL: 'https://subscription-portal.fortellis.io/graphql',
    REACT_APP_MP_DP_METADATA_URL:
      'https://mp-dp-subscription-metadata-svc.fortellis.io',
    REACT_APP_CONSENT_SERVICE_URL: 'https://cdk-prod.apigee.net/',
    REACT_APP_MARKETPLACE_URL: 'https://marketplace.fortellis.io/',
    REACT_APP_AUTHORIZE_URL: 'https://fortellis-connect-cdk-proxy.na.connectcdk.com',
    REACT_APP_NAV_DEVELOPER_COMMUNITY_URL: '#',
    REACT_APP_NAV_MARKETPLACE_URL: '#',
    REACT_APP_NAV_DEVELOPER_APIS_URL: '#',
    REACT_APP_NAV_DOCS_URL: 'https://docs.fortellis.io',
    REACT_APP_CONTACT_US_URL: '#',
    REACT_APP_BLOG_URL: '#',
    REACT_APP_LEGAL_URL: 'https://fortellis.io/privacy-legal',
    REACT_APP_TERMS_URL: 'https://fortellis.io/terms-use',
    FORGET_PASSWORD_LINK: 'https://sso.dealersuite.com/idp/forgotLogin',
    ORGANIZATION_URL: 'https://organizations.fortellis.io/v1',
    SIGNING_REDIRECT_URL: 'https://subscription-portal.fortellis.io/redirecting',
    REACT_APP_MP_SALESFORCE_INTEGRATION:
      'https://marketplace-salesforce-integration.fortellis.io',
    EXSTING_DEALER_PORTAL: 'https://ds.fortellis.io',
    REACT_APP_AMPLITUDE: '5f7e4cf6330af44330c96a64631b3fe9',
    REACT_APP_API_SUBSCRIPTION_URL: 'https://subscriptions.fortellis.io',
    REACT_APP_DEALERSUITE_URL: 'https://subscription-portal.fortellis.io/',
    MONETIZATION_SERVICE_AGREEMENT_DOC_URL: "https://marketplace-prod-admin-dealer-consent-docs.s3.us-west-2.amazonaws.com/MonetisationServiceAgreement/Fortellis+-+Stripe+-+Dealer+Addendum+to+Master+Services+Agreement.pdf",
    CONNECT_CDK_FORGOT_PASSWORD_URL: "https://login.connectcdk.com/login/forgot-password",
    DATA_RIGHTS_PDF: "https://marketplace-data-rights-consent.s3.us-west-2.amazonaws.com/DataRightsConsent.pdf",
    REACT_APP_PRIVACY_PROTECTION_URL: 'https://consumer-privacy-protection.fortellis.io',
    REACT_APP_SHOW_INTEGRATIONS_SCREEN: true,
    REACT_APP_SHOW_VERTICAL_SCOPING_SCREEN: true,
    REACT_APP_DAAB_HARNESS_CLIENT_SDK_KEY: '8ab4246b-c29a-4cee-9be4-1c09ab5c0386',
    REACT_APP_DAAB_FEATURE_FLAG : 'dealer_api_buyer_controlled_access_prod',
    REACT_APP_DEALER_API_BUYER_DOC: "https://fortellis-consent-documents-prod.s3.us-west-2.amazonaws.com/dealer-api-buyer-flow/DealerAPIBuyer.pdf",
    ENABLE_MANAGE_INTEGRATIONS_V2: true,
    REACT_APP_DEALER_API_BUYER_SERVICE_URL: "https://dealer-api-buyer.fortellis.io",
    REACT_APP_API_GATEWAY: "https://api-gateway.fortellis.io",
    REACT_APP_ASYNC_API_SERVICE: "https://async-apis-control.fortellis.io",
    REACT_APP_API_EMAIL_DISPATCHER_SERVICE:"https://xtpgbgx2p0.execute-api.us-west-2.amazonaws.com/api/email",
    REACT_APP_API_EMAIL_SOLUTION_SERVICE:"https://solutions.fortellis.io",
    REACT_APP_UTILIZATION_SERVICE_URL:"https://utilization.fortellis.io",
    REACT_APP_METRICS_SERVICE_URL : "https://core.fortellis.io/v1",
    REACT_APP_API_GATEWAY_DIRECTORY_URL: "https://api-gateway.fortellis.io/v3",
    REACT_APP_METRICS_SERVICE_URL_V1: "https://metrics.fortellis.io/v1",
    REACT_APP_DAAB_HIDE_DEALER_PURCHASE: 'daab_hide_dealer_purchase_prod',
    REACT_APP_BUNDLE_PRICING_ENABLED: 'BUNDLE_PRICING_ENABLED',
    REACT_APP_NAV_CASE_MANAGEMENT_URL:"https://developer.cdkcare.com/s/"
  }
};

const environment = () => {
  let appHost = window.location.host.toLowerCase();
  if (appHost.indexOf('localhost') > -1) {
    return _config.dev;
  }
  if (appHost.indexOf('subscription-portal-dev') > -1) {
    return _config.dev;
  }
  if (appHost.indexOf('subscription-portal-qat') > -1) {
    return _config.qat;
  }
  return _config.prod;
};

export const environmentURLs = environment();
